











































































































































































































































































































import Component from 'vue-class-component';
import FeedbackComponent from '@/components/base/FeedbackComponent';
import { ChildrenDetails } from '@/models/form/ChildrenDetails.model';
import MockData from '@/globals/mock';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Action, Getter, Mutation } from 'vuex-class';
import { Document, Documents } from '@/models/form/Documents.model';
import { Utils } from '@/globals/Utils';
import { InputFile } from '@/models/InputFile.model';
import { Inject } from 'vue-property-decorator';
import {
  ADD_EMPLOYEE_CHILD,
  FORM101_DATA,
  FORM101_META_DATA,
  FORM_READ_ONLY_MODE,
  REMOVE_EMPLOYEE_CHILD,
  SET_FORM101_DATA,
  UPDATE_EMPLOYEE_CHILD_DETAILS,
} from '@/types/form.types';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import {
  DELETE_DOCUMENT,
  DOCUMENTS, DOCUMENTS_ERRORS,
  DOWNLOAD_DOCUMENT,
  GET_DOCUMENT_LIST,
  UPLOAD_CLICKED,
  UPLOAD_DOCUMENT,
} from '@/types/documents.types';
import { GET_MANAGER_DOCUMENT_CONTENT, MANAGER_MODE } from '@/types/managerForm.types';
import { UPLOAD_FILE_ENABLE } from '@/types/lobby.types';
import { Form101MetaData } from '@/models/form/Form101MetaData.model';

@Component({})
export default class ChildrenDetailsStep extends FeedbackComponent {

  @Inject() public $validator: any;

  @Action(UPLOAD_DOCUMENT, StoreNamespace.DOCUMENT) public uploadDocument;
  @Action(UPLOAD_CLICKED, StoreNamespace.DOCUMENT) public uploadClicked;
  @Action(DELETE_DOCUMENT, StoreNamespace.DOCUMENT) public deleteDocument;
  @Action(DOWNLOAD_DOCUMENT, StoreNamespace.DOCUMENT) public downloadDocument;
  @Action(GET_MANAGER_DOCUMENT_CONTENT, StoreNamespace.MANAGER) public managerDownloadDocument;
  @Action(GET_DOCUMENT_LIST, StoreNamespace.DOCUMENT) public getDocumentList;

  @Mutation(UPDATE_EMPLOYEE_CHILD_DETAILS, StoreNamespace.FORM) public updateEmployeeChildDetails;
  @Mutation(ADD_EMPLOYEE_CHILD, StoreNamespace.FORM) public addEmployeeChild;
  @Mutation(REMOVE_EMPLOYEE_CHILD, StoreNamespace.FORM) public removeEmployeeChild;
  @Mutation(SET_FORM101_DATA, StoreNamespace.FORM) public setForm101Data;

  @Getter(MANAGER_MODE, StoreNamespace.MANAGER) public managerMode!: boolean;
  @Getter(FORM_READ_ONLY_MODE, StoreNamespace.FORM) public formReadOnlyMode!: boolean;
  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
  @Getter(DOCUMENTS, StoreNamespace.DOCUMENT) public documents!: Documents;
  @Getter(DOCUMENTS_ERRORS, StoreNamespace.DOCUMENT) public documentsErrors!: string[];
  @Getter(UPLOAD_FILE_ENABLE, StoreNamespace.AUTHENTICATION) public uploadFileEnable!: boolean;
  @Getter(FORM101_META_DATA, StoreNamespace.FORM) public form101MetaData!: Form101MetaData;

  public upload300FileModal = false;
  private mockData: any = {};
  private deleteChildModal: boolean = false;
  private disableDeleteChildModal: boolean = false;
  private indexToDelete: number | null = null;

  public created() {
    if(this.form101Data.children){
      for (const child of this.form101Data.children) {
        child.childBirthDateHalper = child.childBirthDate ? Utils.stringToDate('' + child.childBirthDate) : null;
        child.uniqueId = '' + (Math.random() * 10000);
      }
    }
    this.mockData = MockData.form101;
  }

  public onUploadClicked(inputFile: InputFile, docType: number) {
    this.uploadClicked({
      requestBody: {
        inputFile,
        docType,
        formId: this.form101Data.formId,
      },
    });
  }

  public onDownloadClicked(file: InputFile) {
    if (this.managerMode) {
      this.managerDownloadDocument({
        requestBody: {
          docId: file.docId,
          docName: file.docName,
          mimeType: file.type,
          officeNum: this.form101Data.officeNum,
          idNum: this.form101Data.idNum,
          positionNum: this.form101Data.positionNum,
        },
      });
    } else {
      this.downloadDocument({
        requestBody: {
          docId: file.docId,
          docName: file.docName,
          mimeType: file.type,
        },
      });
    }
  }

  public onRemovedClicked(file: Document) {
    this.deleteDocument(file.docId);
  }

  public openDeleteChildModal(index: number) {
    const child = this.form101Data.children[index];
    if (child.childIdNumber != null &&
        child && child.originalRelativeIdNumber == child.childIdNumber) {
      this.disableDeleteChildModal = true;
      this.deleteChildModal = false;
    } else {
      this.disableDeleteChildModal = false;
      this.deleteChildModal = true;
    }
    this.indexToDelete = index;
  }

  public closeDeleteChildModal() {
    this.deleteChildModal = false;
    this.indexToDelete = null;
  }

  public deleteChild() {
    this.removeEmployeeChild(this.indexToDelete);
    if (!this.form101Data.children.length) {
      this.documents.childrenFiles.forEach((file) => {
        this.onRemovedClicked(file);
      });
    }
    this.closeDeleteChildModal();
  }

  public closeDisableDeleteChildModal() {
    this.disableDeleteChildModal = false;
  }

  public addChild() {
    if (this.form101Data.children.length < 13) {
      const child: ChildrenDetails = {
        childIdNumber: '',
        childName: '',
        childBirthDate: '',
        childBirthDateHalper: undefined,
        childGender: null,
        childCustody: false,
        childPay: false,
        uniqueId: '' + (Math.random() * 10000),
      } as ChildrenDetails;
      this.addEmployeeChild(child);
    }
  }

  public updateChildBirthDate(date: Date, index: number) {
    this.updateChild(date ? Utils.dateToString(date) : date, index, 'childBirthDate');
  }

  public updateChildCheckboxes(dataModel: ChildrenDetails, index: number) {
    if (dataModel.childCustody !== undefined) {
      this.updateChild(dataModel.childCustody, index, 'childCustody');
    }
    if (dataModel.childPay !== undefined) {
      this.updateChild(dataModel.childPay, index, 'childPay');
    }
  }

  public updateChild(value: string | boolean, index: number, property: string) {
    this.updateEmployeeChildDetails({ value, index, property });
  }

  public open300FileDialog() {
    this.upload300FileModal = true;
  }

  public close300FileDialog() {
    this.upload300FileModal = false;
  }

  public openDeleteDialog(index: number, files: any[]) {
    if (files[index].docId) {
      this.$root.$emit('openDeleteFileDialog', files[index]);
    }
  }


}
